import type { FirebaseUser } from '@modules/firebase';
import { createContext } from 'react';

const initialContext = {
  user: undefined,
};

interface anonymousUserContextValues {
  user: FirebaseUser | undefined;
}

const anonymousUserContext = createContext<anonymousUserContextValues>(initialContext);

export { anonymousUserContext };
